import { Time } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnDestroy, ViewChild, ViewEncapsulation, ɵgetHostElement, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePickerComponent, TimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent, RadioButtonDirective } from '@progress/kendo-angular-inputs';
import { FormatService } from '~/services/administration.ts/format';
import { UsersService } from '~/services/administration.ts/users';
import { ReportsService } from '~/services/modules/reports/reports';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';

@Component({
    selector: 'stock-schedule-report',
    templateUrl: './schedule.html',
    styleUrls: ['./schedule.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class scheduleReportComponent implements OnDestroy {
    _theme: string;
    _currentPattern: string;
    _currenDayliPattern: string;
    _currenMonthlyPattern: string;
    _currenYearlyPattern: string;
    _currentenableEndDate: string;
    _currentWeeklyRecDayseventvalue: Array<any>;
    _active: boolean = true;
    _currentDate: Date = new Date();
    _dateTimeFormat = 'MM/dd/yyyy HH:mm';
    _dateFormat = 'MM/dd/yyyy';
    _selectedDateTime: Date = new Date();
    _TimeFormat = 'HH:mm';
    _form: FormGroup;
    _repoortId: number;
    _persons: any[];
    _personsFiltered: any[];
    _selectedPersons: any[] = [];
    selectedFields: any[] = [];
    _listOfReportFormats: Array<any> = [
        { id: 1, code: 'pdf' },
        { id: 2, code: 'excel' },
        { id: 3, code: 'csv' },
        { id: 4, code: 'word' }
    ];
    _listOfStartingAt: Array<string> = [
        'First',
        'Second',
        'Third',
        'Last'
    ];
    _listOfDays: Array<string> = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    _listOfMonths: Array<string> = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    _runTimeData: Array<string> = [
        'hourly',
        'daily',
        'weekly',
        'monthly',
        'yearly',
    ];
    _weeklyRecDays: Array<any> = [
        {
            id: 'sunday',
            title: 'Sunday'
        },
        {
            id: 'monday',
            title: 'Monday'
        },
        {
            id: 'tuesday',
            title: 'Tuesday'
        },
        {
            id: 'wednesday',
            title: 'Wednesday'
        },
        {
            id: 'thursday',
            title: 'Thursday'
        },
        {
            id: 'friday',
            title: 'Friday'
        },
        {
            id: 'saturday',
            title: 'Saturday'
        }
    ];
    _dailyRecPatternData: Array<string> = [
        'Every Day',
        'Every Weekday'
    ];
    _monthlyRecPatternData: Array<string> = [
        'Specific Date',
        'Specific Day'
    ];
    _yearlyRecPatternData: Array<string> = [
        'Specific Day',
        'Specific Date'
    ];
    _enableEndDateData: Array<string> = [
        'With End Date',
        'No End Date'
    ];
    _runTimeUnit: string;
    _runTimeDateDaily: string = 'dayselection';
    _runTimeDateMonthly: string = 'monthlyday';
    _runTimeDateYearly: string = 'yearlydate';
    _runTimeDateMode: string = 'noenddate';
    currentStep = 1;
    _selectedweeklyRecDays: any[] = [];
    _datePickerFormat: string;
    _costFormat: string;

    @ViewChild('kendo_customized_date_picker') kendoCustomizedDatePicker: DatePickerComponent;
    @ViewChild('kendo_customized_time_picker') kendoCustomizedTimePicker: TimePickerComponent;
    @ViewChild('kendo_Date_Picker_EndBy') kendoDatePickerEndBy: DatePickerComponent;
    @ViewChild('kendo_Combo_Rec_Pattern_Notification') kendoComboRecPatternNotification: ComboBoxComponent;
    @ViewChild('Kendo_NumericBox_RecurrHourly') kendoNumericBoxRecurrHourly: NumericTextBoxComponent;
    @ViewChild('Kendo_NumericBox_RecurrDaily') kendoNumericBoxRecurrDaily: NumericTextBoxComponent;

    @ViewChild('Monthly_Specific_ofEvery_numeric') MonthlySpecificofEverynumeric: NumericTextBoxComponent;
    @ViewChild('the_specific_NextDay') thespecificNextDay: ComboBoxComponent;
    @ViewChild('of_every_month_specific_numeric') ofOveryMonthSpecificNumeric: NumericTextBoxComponent;
    @ViewChild('recurr_every_year_numericbox') recurreveryyearnumericbox: NumericTextBoxComponent;





    @ViewChild('kendo_Combo_Rec_Pattern') kendoComboRecPattern: ComboBoxComponent;
    @ViewChild('kendo_Combo_Daily_Rec_Pattern') kendoComboDailyRecPattern: ComboBoxComponent;
    @ViewChild('kendo_Combo_Enable_End_Date') kendoComboEnableEndDate: ComboBoxComponent;
    @ViewChild('Kendo_NumericBox_RecurrWeekly') KendoNumericBoxRecurrWeekly: NumericTextBoxComponent;
    @ViewChild('kendo_multiselect_wrapper') kendoMultiselectWrapper: ElementRef;
    @ViewChild('kendo_multiselect') kendoMultiselect: MultiSelectComponent;
    @ViewChild('kendo_Combo_Monthly_Rec_Pattern') kendoComboMonthlyRecPattern: ComboBoxComponent;
    @ViewChild('Monthly_Specific_day_numeric') MonthlySpecificDayNumeric: NumericTextBoxComponent;
    @ViewChild('kendo_combo_specific_month') kendoComboSpecificMonth: ComboBoxComponent;
    @ViewChild('kendo_Combo_Yearly_Rec_Pattern') kendoComboYearlyRecPattern: ComboBoxComponent;
    @ViewChild('week_Number_Combo') weekNumberCombo: ComboBoxComponent;
    @ViewChild('onYearDate_datepicker') onYearDateDatepicker: DatePickerComponent;
    @ViewChild('yearly_Weekday_Choose_Combo') yearlyWeekdayChooseCombo: ComboBoxComponent;
    @ViewChild('yearly_Month_Choose_Combo') yearlyMonthChooseCombo: ComboBoxComponent;
    @ViewChild('kendo_Choose_End_Date') kendoChooseEndDate: DatePickerComponent;
    @ViewChild('kendo_Combo_Report_Format') kendoComboReportFormat: ComboBoxComponent;

    @Input() model: any;

    constructor(
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _fb: FormBuilder,
        private _reportsService: ReportsService,
        private _usersService: UsersService,
        private _formatService: FormatService,
        private _layoutComponent: LayoutComponent,
        @Inject(PORTAL_DATA) public data: any,
        @Inject(DOCUMENT) private document: Document
    ) {
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this._layoutManager.applyOverly();

        this._repoortId = this.data.model.reportId;
    }


    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }
    //#region  ngOnInit
    ngOnInit() {
        this._initForm();
        this._LoadPersonsDD();
        setTimeout(() => {
            this.kendoCustomizedDatePicker.toggle(true);
        });
        /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;

    }
    //#endregion
    ngOnDestroy() {
        this._layoutManager.removeOverlay();
        this.document.body.classList.remove('customizedtimepicker');
        this._layoutComponent.detachDialogForm();
    }
    _openedCombo() {
        let patterncombo = this.kendoComboRecPattern;
        ɵgetHostElement(patterncombo).classList.add('openedCombo');
    }
    _closedCombo() {
        setTimeout(() => {
            let patterncombo = this.kendoComboRecPattern;
            ɵgetHostElement(patterncombo).classList.remove('openedCombo');
        }, 100);

    }
    _onpersonChange(e: any) {
        this._selectedPersons = e;
    }
    _skipCombo() {
        this.currentStep = 4;
        setTimeout(() => {
            let patterncombo = this.kendoComboRecPattern;
            ɵgetHostElement(patterncombo).classList.remove('openedCombo');
            this.kendoComboRecPattern.toggle(false);
            this.kendoComboRecPatternNotification.toggle(true);
        });
    }
    _scheduleStartDateEvent() {
        setTimeout(() => {
            this.kendoDatePickerEndBy.toggle(false);
        });
    }
    _removeTime() {
        this._dateTimeFormat = 'MM/dd/yyyy';
        this.document.body.classList.remove('customizedtimepicker');
        setTimeout(() => {
            let visibleDateField = this.kendoCustomizedDatePicker;
            visibleDateField.wrapper.nativeElement.firstElementChild.classList.remove('k-state-focused');
            this.kendoCustomizedTimePicker.toggle(false);
            this.kendoComboRecPattern.toggle(true);
            this.kendoComboRecPattern.focus();
            let patterncombo = this.kendoComboRecPattern;
            ɵgetHostElement(patterncombo).classList.add('openedCombo');
        });
        this.currentStep = 2;
    }
    _withTime() {
        this._dateTimeFormat = 'MM/dd/yyyy HH:mm';
        this.document.body.classList.add('customizedtimepicker');
        setTimeout(() => {
            let visibleDateField = this.kendoCustomizedDatePicker;
            visibleDateField.wrapper.nativeElement.firstElementChild.classList.add('k-state-focused');
            this.kendoDatePickerEndBy.toggle(false);
        }, 100);
    }
    _removeBodyClass() {
        setTimeout(() => {
            this.document.body.classList.remove('customizedtimepicker');
            let visibleDateField = this.kendoCustomizedDatePicker;
            visibleDateField.wrapper.nativeElement.firstElementChild.classList.remove('k-state-focused');
            this.kendoComboRecPattern.toggle(true);
            this.kendoComboRecPattern.focus();
            let patterncombo = this.kendoComboRecPattern;

            ɵgetHostElement(patterncombo).classList.add('openedCombo');
        }, 100);
        this.currentStep = 2;
    }
    _movetoRangeStep() {
        setTimeout(() => {
            this.currentStep = 3;
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
        });
    }

    _endByDatePickerEvent() {
        setTimeout(() => {
            this.currentStep = 4;
            this.kendoChooseEndDate.toggle(false);
            let endbyDatePicker = this.kendoChooseEndDate;
            endbyDatePicker.wrapper.nativeElement.firstElementChild.classList.remove('k-state-focused');
        });
    }
    _noEndDateFunction() {
        this.currentStep = 3;
        setTimeout(() => {
            this.kendoDatePickerEndBy.toggle(false);
            let endbyDatePicker = this.kendoDatePickerEndBy;
            endbyDatePicker.wrapper.nativeElement.firstElementChild.classList.remove('k-state-focused');
        });
    }
    _closeCalendar() {
        setTimeout(() => {
            this.kendoCustomizedTimePicker.toggle();
            let visibleDateField = this.kendoCustomizedDatePicker;
            visibleDateField.wrapper.nativeElement.firstElementChild.classList.add('k-state-focused');
        }, 100);
        this._dateTimeFormat = 'MM/dd/yyyy HH:mm';
        this.document.body.classList.add('customizedtimepicker');
    }
    _openEndByDatePicker() {
        setTimeout(() => {
            this.kendoDatePickerEndBy.toggle(true);
            this.kendoCustomizedTimePicker.toggle(false);
            this.kendoCustomizedDatePicker.toggle(false);
            this.currentStep = 3;
        });
    }
    _endByComboROF() {
        setTimeout(() => {
            this.kendoCustomizedTimePicker.toggle(false);
            this.kendoCustomizedDatePicker.toggle(false);
            this.document.body.classList.remove('customizedtimepicker');
            this.currentStep = 3;
        }, 101);
    }
    _recurrencePatternChange(value: any) {
        this._currentPattern = value;
        this.currentStep = 2;
        if (this._currentPattern === 'hourly') {
            setTimeout(() => {
                this.kendoNumericBoxRecurrHourly.focus();
            });
        }
        if (this._currentPattern === 'daily') {
            setTimeout(() => {
                this.kendoComboDailyRecPattern.toggle(true);
                this.kendoComboDailyRecPattern.focus();
            });
        }
        if (this._currentPattern === 'weekly') {
            setTimeout(() => {
                this.KendoNumericBoxRecurrWeekly.focus();
            });
        }
        if (this._currentPattern === 'monthly') {
            setTimeout(() => {
                this.kendoComboMonthlyRecPattern.toggle(true);
                this.kendoComboMonthlyRecPattern.focus();
            });
        }
        if (this._currentPattern === 'yearly') {
            setTimeout(() => {
                this.recurreveryyearnumericbox.focus();
            });
        }
    }
    _dailyRecurrencePatternChange(value: any) {
        this._currenDayliPattern = value;
        this.currentStep = 2;
        if (this._currenDayliPattern === 'Every Day') {
            setTimeout(() => {
                this.kendoNumericBoxRecurrDaily.focus();
            });
        }
        if (this._currenDayliPattern === 'Every Weekday') {
            setTimeout(() => {
                this.currentStep = 3;
                this.kendoComboEnableEndDate.toggle(true);
                this.kendoComboEnableEndDate.focus();
            });
        }
    }

    _monthlyRecurrencePatternChange(value: any) {
        this._currenMonthlyPattern = value;
        this.currentStep = 2;
        if (this._currenMonthlyPattern === 'Specific Date') {
            setTimeout(() => {
                this.MonthlySpecificDayNumeric.focus();
            });
        }
        if (this._currenMonthlyPattern === 'Specific Day') {
            setTimeout(() => {
                this.kendoComboSpecificMonth.toggle(true);
                this.kendoComboSpecificMonth.focus();
            });
        }
    }
    _yearlyRecurrencePatternChange(value: any) {
        this._currenYearlyPattern = value;
        this.currentStep = 2;
        if (this._currenYearlyPattern === 'Specific Date') {
            setTimeout(() => {
                this.onYearDateDatepicker.toggle(true);
                this.onYearDateDatepicker.focus();
            });
        }
        if (this._currenYearlyPattern === 'Specific Day') {
            setTimeout(() => {
                this.weekNumberCombo.toggle(true);
                this.weekNumberCombo.focus();
            });
        }
    }

    _noEndDateEvent() {
        this.currentStep = 4;
        setTimeout(() => {
            this.kendoComboRecPatternNotification.toggle(true);
            this.kendoComboRecPatternNotification.focus();
            this.kendoMultiselect.toggle(false);
        });
    }
    _weeklyRecDaysevent(e: any) {
        this._currentWeeklyRecDayseventvalue = e;
    }

    _isItemSelected(id: any) {
        return this._currentWeeklyRecDayseventvalue ? this._currentWeeklyRecDayseventvalue.some(item => item.id === id) : false;
    }
    _multiSelectClose(e: any) {
        if (!ɵgetHostElement(this.kendoMultiselect).contains(e.target)) {
            this.kendoMultiselect.toggle(false);
        }
    }
    _daysRecMultiselectEvent() {
        this.currentStep = 3;
    }
    _movetoROF() {
        this.currentStep = 3;
        setTimeout(() => {
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
            this.kendoMultiselect.toggle(false);
        });
    }
    _monthlyNumberofMonth() {
        setTimeout(() => {
            this.currentStep = 3;
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
            this.kendoMultiselect.toggle(false);
        });
    }
    _daysRecMultiselectclose() {
        this.currentStep = 3;
        setTimeout(() => {
            this.kendoMultiselect.toggle(false);
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
        });
    }
    _movetodaysMultiSelect() {
        setTimeout(() => {
            this.kendoMultiselect.toggle(true);
        });
    }
    _movetoofEveryRadio() {
        this.MonthlySpecificofEverynumeric.focus();
    }

    _openNextSpecificDay() {
        setTimeout(() => {
            this.thespecificNextDay.toggle(true);
            this.thespecificNextDay.focus();
        });
    }

    _focusOfEveryMonth() {
        setTimeout(() => {
            this.ofOveryMonthSpecificNumeric.focus();
        });
    }
    _moveToYearlyTypeRecurrencePattern() {
        setTimeout(() => {
            this.kendoComboYearlyRecPattern.toggle(true);
            this.kendoComboYearlyRecPattern.focus();
        });
    }
    _yearlyChooseWeekNumberEvent() {
        setTimeout(() => {
            this.yearlyWeekdayChooseCombo.toggle(true);
            this.yearlyWeekdayChooseCombo.focus();
        });
    }
    _yearlyChooseWeekdayNumberEvent() {
        setTimeout(() => {
            this.yearlyMonthChooseCombo.toggle(true);
            this.yearlyMonthChooseCombo.focus();
        });
    }
    _yearlyChooseMonthEvent() {
        setTimeout(() => {
            this.currentStep = 3;
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
        });
    }
    _movetosheduleDate() {
        setTimeout(() => {
            this.currentStep = 3;
            let onYearDateDatepickervalue = this.onYearDateDatepicker;
            onYearDateDatepickervalue.wrapper.nativeElement.firstElementChild.classList.remove('k-state-focused');
            this.kendoComboEnableEndDate.toggle(true);
            this.kendoComboEnableEndDate.focus();
        });
    }
    _enableEndDateChange(value: any) {
        this._currentenableEndDate = value;
        this.currentStep = 3;
        if (this._currentenableEndDate === 'With End Date') {
            setTimeout(() => {
                this.kendoChooseEndDate.toggle(true);
                this.kendoChooseEndDate.focus();
            });
        }
        if (this._currentenableEndDate === 'No End Date') {
            this.currentStep = 4;
        }
    }
    _reportFormatOpen() {
        this.currentStep = 5;
    }
    private _initForm() {
        this._form = this._fb.group({
            dailyRecPattern: [this.model ? this.model.dayselection ? 'Every Day' : 'Every Weekday' : null],
            monthlyRecPattern: [this.model ? this.model.monthlyspecific ? 'Specific Date' : 'Specific Day' : null],
            yearlyRecPattern: [this.model ? this.model.yearlydate ? 'Specific Date' : 'Specific Day' : null],
            enableEndDate: [this.model ? this.model.scheduleenddate ? 'With End Date' : 'No End Date' : null],

            runtimeunit: [this.model ? this.model.runtimeunit : this._runTimeUnit],
            runtimedatemode: [this.model ? this.model.runtimedate : this._runTimeDateMode],
            runtimedatedaily: [this.model ? this.model.runtimedatedaily : this._runTimeDateDaily],
            runtimedatemonthly: [this.model ? this.model.runtimedatedaily : this._runTimeDateMonthly],
            runtimedateyearly: [this.model ? this.model.runtimedatedaily : this._runTimeDateYearly],
            person: [this.model ? this.model.person : []],
            reportformat: [this.model ? this.model.reportFormat : this._listOfReportFormats[0]],
            schedulestartdate: [this.model ? this.model.schedulestartdate : this._currentDate],
            hourlyselection: [this.model ? this.model.hourlyselection : false],
            hourlynumberofhours: [this.model ? this.model.hourlynumberofhours : 3],
            dailyselection: [this.model ? this.model.dailyselection : false],
            dayselection: [this.model ? this.model.dayselection : false],
            dayeveryhowmanydays: [this.model ? this.model.dayeveryhowmanydays : 1],
            dayeveryweekday: [this.model ? this.model.dayeveryweekday : false],
            weeklyselection: [this.model ? this.model.weeklyselection : false],
            weeklyrecurs: [this.model ? this.model.weeklyrecurs : 1],
            weeklyeverysunday: [this.model ? this.model.weeklyeverysunday : false],
            weeklyeverymonday: [this.model ? this.model.weeklyeverymonday : false],
            weeklyeverytuesday: [this.model ? this.model.weeklyeverytuesday : false],
            weeklyeverywednesday: [this.model ? this.model.weeklyeverywednesday : false],
            weeklyeverythursday: [this.model ? this.model.weeklyeverythursday : false],
            weeklyeveryfriday: [this.model ? this.model.weeklyeveryfriday : false],
            weeklyeverysaturday: [this.model ? this.model.weeklyeverysaturday : false],
            monthlyselection: [this.model ? this.model.monthlyselection : false],
            monthlyday: [this.model ? this.model.monthlyday : false],
            monthlydaydate: [this.model ? this.model.monthlydaydate : 1],
            monthlydayeverymonth: [this.model ? this.model.monthlydayeverymonth : 1],
            monthlyspecific: [this.model ? this.model.monthlyspecific : false],
            monthlyspecificrank: [this.model ? this.model.monthlyspecificrank : this._listOfStartingAt[0]],
            monthlyspecificday: [this.model ? this.model.monthlyspecificday : this._listOfDays[0]],
            monthlyspecificeverymonth: [this.model ? this.model.monthlyspecificeverymonth : 1],
            yearlyselection: [this.model ? this.model.yearlyselection : false],
            yearlyrecurs: [this.model ? this.model.yearlyrecurs : 1],
            yearlydate: [this.model ? this.model.yearlydate : false],
            yearlydateon: [this.model ? this.model.yearlydateon : this._currentDate],
            yearlyspecific: [this.model ? this.model.yearlyspecific : false],
            yearlyspecificrank: [this.model ? this.model.yearlyspecificrank : this._listOfStartingAt[0]],
            yearlyspecificday: [this.model ? this.model.yearlyspecificday : this._listOfDays[0]],
            yearlyspecificmonth: [this.model ? this.model.yearlyspecificmonth : this._listOfMonths[0]],
            scheduleenddate: [this.model ? this.model.scheduleenddate : false],
            scheduleenddatevalue: [this.model ? this.model.scheduleenddatevalue : this._currentDate],
            duenext: [this.model ? this.model.duenext : null],
            ToEmailPersonsIds: [this.model ? this.model.ToEmailPersonsIds : null],
            reportid: this._repoortId
        });

        this._form.controls['runtimeunit'].valueChanges.subscribe((x) => {
            this._runTimeUnit = x;
        });
    }

    async _LoadPersonsDD() {
        (await this._usersService.getPersons()).subscribe((persons: any) => {
            this._persons = persons;
            this._personsFiltered = this._persons;
        });
    }

    _handlePersonFilter(value: any) {
        this._personsFiltered = this._persons.filter(
            (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _onSave(e: any) {
        this.submit();
    }

    _onCancel() {
        this._closeForm();
    }

    _onView() {
        this._closeForm();
    }

    _onDelete() {
        this._closeForm();
    }

    _closeForm() {
        this._active = false;
        this.ngOnDestroy();
    }

    

    _onEditForm() { }

    private submit = () => {
        const model = this._form.value;
        model.reportformat = model.reportformat.id;
        if (this._selectedPersons.length == 0) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please choose the User to email the report to.',
                withoutConfirm: true
            });
            return;
        }
        model.ToEmailPersonsIds = this._selectedPersons.map(person => person.id);
        switch (model.runtimeunit) {
            case 'hourly':
                model.hourlyselection = true;
                break;
            case 'daily':
                model.dailyselection = true;
                break;
            case 'weekly':
                model.weeklyselection = true;
                break;
            case 'monthly':
                model.monthlyselection = true;
                break;
            case 'yearly':
                model.yearlyselection = true;
                break;
            default:
                break;
        }
        switch (model.enableEndDate) {
            case 'No End Date':
                model.scheduleenddate = false;
                model.scheduleenddatevalue = null;
                break;
            case 'With End Date':
                model.scheduleenddate = true;
                break;
            default:
                break;
        }
        switch (model.dailyRecPattern) {
            case 'Every Day':
                model.dayselection = true;
                break;
            case 'Every Weekday':
                model.dayeveryweekday = true;
                break;
            default:
                break;
        }
        switch (model.monthlyRecPattern) {
            case 'Specific Day':
                model.monthlyday = true;
                break;
            case 'Specific Date':
                model.monthlyspecific = true;
                break;
            default:
                break;
        }
        switch (model.yearlyRecPattern) {
            case 'Specific Date':
                model.yearlydate = true;
                break;
            case 'Specific Day':
                model.yearlyspecific = true;
                break;
            default:
                break;
        }
        if (this.model) {
            this._reportsService
                .updateScheduleReport(this.model.id, model)
                
                .subscribe(() => {
                    this._closeForm();
                });
        } else {
            this._reportsService
                .createScheduleReport(model)
                
                .subscribe((data: any) => {
                    this._closeForm();
                });
        }
    }
}
